import {
    collection,
    doc,
    getDocs,
    updateDoc,
    query,
    where,
    orderBy,
    writeBatch
} from "firebase/firestore";
import { trackerDb } from "../config";

export const saveRoundMatches = async (roundData) => {
    try {
        const batch = writeBatch(trackerDb);
        const scoutingRef = collection(trackerDb, 'scouting');

        roundData.matches.forEach((match) => {
            const players = match.player_match_relationships.map(rel =>
                rel.user_event_status?.best_identifier || 'Unknown'
            );

            const matchData = {
                round_number: roundData.round_number,
                round_id: roundData.id,
                table_number: match.table_number,
                players: players,
                match_id: match.id,
                status: match.status,
                description_1: '',
                description_2: '',
                ink_colors_1: [],
                ink_colors_2: [],
                created_at: new Date(),
                updated_at: new Date()
            };

            const documentId = `round_${roundData.round_number}_${match.table_number}`;
            const matchDocRef = doc(scoutingRef, documentId);
            batch.set(matchDocRef, matchData);
        });

        await batch.commit();
        return { success: true, matchesCount: roundData.matches.length };
    } catch (error) {
        console.error("Błąd podczas zapisywania meczów rundy:", error);
        throw error;
    }
};

export const getScoutingMatches = async () => {
    try {
        const scoutingRef = collection(trackerDb, 'scouting');
        const q = query(scoutingRef, orderBy('created_at', 'desc'));
        const querySnapshot = await getDocs(q);

        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error("Błąd podczas pobierania meczów scouting:", error);
        throw error;
    }
};

export const deleteRoundMatches = async (roundId) => {
    try {
        const scoutingRef = collection(trackerDb, 'scouting');
        const q = query(scoutingRef, where('round_id', '==', roundId));
        const querySnapshot = await getDocs(q);

        const batch = writeBatch(trackerDb);
        querySnapshot.docs.forEach(doc => {
            batch.delete(doc.ref);
        });

        await batch.commit();
        return { success: true, deletedCount: querySnapshot.docs.length };
    } catch (error) {
        console.error("Błąd podczas usuwania meczów rundy:", error);
        throw error;
    }
};

export const updateScoutingMatch = async (matchId, updateData) => {
    try {
        const matchRef = doc(trackerDb, 'scouting', matchId);
        await updateDoc(matchRef, updateData);
        return { success: true };
    } catch (error) {
        console.error("Błąd podczas aktualizacji meczu scouting:", error);
        throw error;
    }
};
